import React from 'react';
import { Avatar, Chip } from '@heroui/react';
import { Typography } from '../../../../components';
import { UserNoAvatarIcon } from '../../../../components/icons';
import { OrderData } from '../types';
import { useTranslations } from '../../../../contexts/translation.context';

interface AccountCellProps {
  order: OrderData;
}

const getAccessChipConfig = (status: string, t: (key: string) => string) => {
  switch (status) {
    case 'in_progress':
      return {
        base: 'bg-success/20',
        content: 'text-success',
        label: t('orders.account.accessActive'),
      };
    case 'moderation':
    case 'in_moderation':
      return {
        base: 'bg-[#7828C8]/20',
        content: 'text-[#7828C8]',
        label: t('accounts.status.moderation'),
      };
    case 'waiting':
    case 'pending':
      return {
        base: 'bg-warning/20',
        content: 'text-warning',
        label: t('campaigns.status.waiting') || 'Ожидание',
      };
    case 'completed':
      return {
        base: 'bg-success/20',
        content: 'text-success',
        label: t('campaigns.status.completed') || 'Завершено',
      };
    case 'canceled':
    case 'not_started':
      return {
        base: 'bg-danger/20',
        content: 'text-danger',
        label: t('campaigns.status.inactive') || 'Не активна',
      };
    default:
      return {
        base: 'bg-success/20',
        content: 'text-success',
        label: t('orders.account.accessActive'),
      };
  }
};

const AccountCell: React.FC<AccountCellProps> = ({ order }) => {
  const { t } = useTranslations();
  //@ts-ignore
  const subscriptionType =
    order?.offer?.type === 'free'
      ? 'FREE'
      : order?.offer?.type === 'free_trial' ||
          order?.offer?.type === 'free-trial' ||
          order?.offer?.type === 'trial' ||
          order?.offer?.type === 'paid'
        ? 'Free-trial'
        : 'FREE';
  const accessConfig = getAccessChipConfig(order.model.status, t);
  return (
    <div className="flex items-start gap-3">
      <div className="relative">
        <Avatar
          src={order.account.avatar}
          showFallback
          name={order?.account.username?.slice(0, 1)}
          className="w-10 h-10 rounded-3"
        />
      </div>
      <div className="">
        <div className="flex items-center gap-2 mt-1">
          <div className="flex gap-2">
            <Typography variant="label2">
              {/* @ts-ignore */}
              {order?.campaign?.linkSuffix?.length > 5
                ? order?.campaign?.linkSuffix?.slice(-4)
                : order?.campaign?.linkSuffix || order?.account?.of_id}
            </Typography>
            <div className="flex gap-0.5">
              <a
                target="__blank"
                href={`https://onlyfans.com/${order.account.username}`}
                className="text-blue-600 hover:underline flex items-center gap-1"
              >
                <Typography variant="body2" className="!text-partner">
                  @{order?.account.username}
                </Typography>
              </a>
            </div>
          </div>
        </div>

        {/* Status Chips */}
        <div className="flex flex-wrap gap-2 mt-1">
          <Chip
            size="sm"
            variant="flat"
            classNames={{
              base: ' bg-partner/20',
              content: 'text-partner',
            }}
          >
            {subscriptionType ? subscriptionType : 'FREE'}
          </Chip>
          <Chip
            size="sm"
            color="warning"
            variant="flat"
            classNames={{
              base: ' bg-warning/20',
              content: 'text-warning',
            }}
          >
            {/* //@ts-ignore */}
            {order.account?.overall_popularity_percent || 0}%
          </Chip>
          <Chip
            size="sm"
            classNames={{
              base: accessConfig.base,
              content: accessConfig.content,
            }}
          >
            {accessConfig.label}
          </Chip>
        </div>
      </div>
    </div>
  );
};

export default AccountCell;
